import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * Generic Wizards API service.
 * 
 * Works with any wizard key:
 *   - 'sina_pwa_dashboard_tour_completed'
 *   - 'sina_pwa_forms_tour_completed'
 */
export const wizardsApi = {
    /**
     * GET /v1/wizards/{wizard}
     * Returns the wizard's current state (step, completed, etc.)
     */
    getWizard: (wizardKey) =>
        apiClient.get(API_ENDPOINTS.wizards.getById(wizardKey)).then(res => {
            const data = res.data?.data || res.data || {};
            return data;
        }),

    /**
     * POST /v1/wizards/{wizard}/step
     * Saves the current step progress for a wizard.
     * Body: { step: N }
     */
    saveStep: (wizardKey, step) =>
        apiClient.post(API_ENDPOINTS.wizards.saveStep(wizardKey), { step, current_step: step }).then(res => {
            return res.data?.data || res.data || {};
        }),

    /**
     * POST /v1/wizards/{wizard}/complete
     * Marks the wizard as completed.
     */
    complete: (wizardKey) =>
        apiClient.post(API_ENDPOINTS.wizards.complete(wizardKey)).then(res => {
            return res.data?.data || res.data || {};
        }),
};
